export const idle = "idle";
export const loading = "loading";
export const succeeded = "succeeded";
export const failed = "failed";
